export default {
  admin: 'Yönetici',
  password: {
    enterNewPassword: 'Yeni şifre girin',
    reenterNewPassword: 'Yeni şifreyi tekrar girin',
    updatePassword: 'Şifreyi Güncelle',
    setPassword: 'Şifreyi Ayarla',
    min8CharacterMessage: 'Şifre en az 8 karakter olmalıdır',
    passwordSentMessage: 'Şifre {userName} adresine e-posta ile gönderildi.',
    generateNewPassword: 'Yeni Şifre Oluştur',
    assignPasswordMessage:
      'Kullanıcıya bir şifre atayın. Kullanıcı, bir sonraki girişinde bu şifreyi değiştirmek zorunda kalacaktır.',
    generateSecurePassword: 'Güvenli şifre oluştur',
    newPassword: 'Yeni Şifre',
    confirmNewPassword: 'Yeni Şifreyi Onayla',
    passwordHistory: 'Şifre Geçmişi',
    passwordUpdatedLog: '{userName} tarafından {date} tarihinde şifre güncellendi.',
    forgotPasswordLog: '{userName} tarafından {date} tarihinde şifre unutma talebi gönderildi.',
  },
};
